import { __rest, __assign } from 'tslib';
import React__default from 'react';
import classNames from 'classnames';
import styles from './Input.module.esm.js';

var Input = function (_a) {
    var className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onChange = _a.onChange, placeholder = _a.placeholder, rest = __rest(_a, ["className", "disabled", "onChange", "placeholder"]);
    return (React__default.createElement("input", __assign({ className: classNames(styles.input, className), disabled: disabled, onChange: onChange, placeholder: placeholder }, rest)));
};

export { Input as default };
//# sourceMappingURL=Input.esm.js.map
